import type { DriverResources } from '../en/driver';

export const driver: DriverResources = {
  list: {
    title: 'Fahrer',
    loading: 'Fahrer werden geladen …',
    error: 'Fahrer konnten nicht geladen werden.',
    searchPlaceholder: 'Nach Name, E-Mail oder Personalnummer suchen…',
    empty: {
      title: 'Noch keine Fahrer',
    },
    noResults: {
      title: 'Keine Fahrer gefunden',
      description: 'Passen Sie Suche oder Filter an, um wieder Ergebnisse zu sehen.',
      reset: 'Suche und Filter zurücksetzen',
    },
    columns: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      employeeId: 'Personalnummer',
      email: 'E-Mail',
      status: 'Status',
      phone: 'Festnetz',
      mobile: 'Mobil',
      location: 'Standort',
      department: 'Abteilung',
      costCenter: 'Kostenstelle',
      currentAssignment: 'Aktuelle Zuweisung',
    },
    result: { singular: 'Fahrer', plural: 'Fahrer' },
    actions: { add: 'Fahrer hinzufügen' },
  },
  status: { active: 'Aktiv', inactive: 'Inaktiv' },
  detail: {
    title: 'Fahrer',
    back: 'Alle Fahrer',
    error: 'Fahrer konnte nicht geladen werden.',
    tabs: {
      details: 'Details',
      assignment: 'Fahrzeugzuweisung',
    },
    actions: {
      edit: 'Bearbeiten',
      save: 'Speichern',
      saving: 'Wird gespeichert…',
      activate: 'Fahrer aktivieren',
      deactivate: 'Fahrer deaktivieren',
    },
    toast: {
      updated: 'Änderungen gespeichert',
      activated: 'Fahrer aktiviert',
      deactivated: 'Fahrer deaktiviert',
    },
    unsavedChanges: {
      title: 'Änderungen verwerfen?',
      description: 'Ihre Änderungen an diesem Fahrer wurden nicht gespeichert.',
      keepEditing: 'Weiter bearbeiten',
      discard: 'Verwerfen',
    },
    deactivateConfirm: {
      title: '{{name}} deaktivieren?',
      description: 'Der Fahrer behält seine Daten, kann aber im Produkt nicht mehr ausgewählt werden.',
      descriptionWithVehicle:
        '{{name}} fährt aktuell {{vehicle}}. Beim Deaktivieren wird die Zuweisung beendet und das Fahrzeug freigegeben.',
      // Vorläufiger Text für ein maskiertes Fahrzeug, ausstehende Produktfreigabe.
      descriptionWithVehicleRedacted:
        '{{name}} fährt aktuell ein Fahrzeug. Beim Deaktivieren wird die Zuweisung beendet und das Fahrzeug freigegeben.',
      refused: 'Diesem Fahrer ist noch ein Fahrzeug zugewiesen. Lassen Sie die Zuweisung zuerst beenden.',
      cancel: 'Abbrechen',
      confirm: 'Deaktivieren',
    },
  },
  assignment: {
    title: 'Aktuelle Zuweisung',
    empty: 'Aktuell kein Fahrzeug zugewiesen',
    saveFirst: 'Speichern Sie den Fahrer, bevor Sie ein Fahrzeug zuweisen.',
    assign: 'Fahrzeug zuweisen',
    end: 'Zuweisung beenden',
    inactiveReason: 'Deaktivierte Fahrer können kein Fahrzeug zugewiesen werden.',
    columns: { vehicle: 'Fahrzeug', date: 'Zuweisungsdatum' },
    dialog: {
      assign: {
        title: 'Fahrzeug zuweisen',
        vehicleLabel: 'Fahrzeug',
        vehiclePlaceholder: 'Fahrzeug auswählen…',
        noVehicleAvailable: 'Kein freies Fahrzeug verfügbar',
        startLabel: 'Beginn',
        cancel: 'Abbrechen',
        confirm: 'Fahrzeug zuweisen',
      },
      end: {
        title: 'Zuweisung für {{vehicle}} beenden?',
        description: 'Das Fahrzeug wird für andere Fahrer verfügbar.',
        unknownVehicle: 'dieses Fahrzeug',
        cancel: 'Abbrechen',
        confirm: 'Zuweisung beenden',
      },
    },
    toast: {
      assigned: 'Fahrzeug zugewiesen',
      ended: 'Zuweisung beendet',
      failed: 'Zuweisung konnte nicht gespeichert werden. Bitte erneut versuchen.',
    },
  },
  new: {
    title: 'Fahrer hinzufügen',
    noPermission: 'Sie haben keine Berechtigung, in diesem Mandanten Fahrer anzulegen.',
    actions: { submit: 'Fahrer anlegen', pending: 'Wird angelegt…' },
    toast: { created: 'Fahrer angelegt' },
  },
  form: {
    groups: {
      person: 'Person',
      contact: 'Kontakt',
      organization: 'Organisation',
    },
    fields: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      employeeId: 'Personalnummer',
      email: 'E-Mail',
      phone: 'Festnetz',
      mobile: 'Mobil',
      locationId: 'Standort',
      department: 'Abteilung',
      costCenter: 'Kostenstelle',
    },
    location: {
      none: 'Kein Standort',
    },
    actions: { cancel: 'Abbrechen' },
    validation: { required: 'Pflichtfeld', email: 'Geben Sie eine gültige E-Mail-Adresse ein' },
  },
  // Unused until a roles-management screen exists; kept as ready copy.
  roles: {
    person: { read: 'Fahrer — Person sehen', write: 'Fahrer — Person bearbeiten' },
    contact: { read: 'Fahrer — Kontakt sehen', write: 'Fahrer — Kontakt bearbeiten' },
    organization: { read: 'Fahrer — Organisation sehen', write: 'Fahrer — Organisation bearbeiten' },
    status: { read: 'Fahrer — Status sehen', write: 'Fahrer — Status ändern' },
    assignments: { read: 'Fahrer — Zuweisungen sehen', write: 'Fahrer — Zuweisungen ändern' },
    // Provisional copy, pending product blessing.
    create: 'Fahrer — Fahrer anlegen',
  },
};
